let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cMaqn")).then(() => parcelRequire('bCHFG'));